import { useEffect, useState, useRef } from "react";
import InfoBanner from "../components/Banner.jsx";
import ImageSection from "../components/Home/Solutions.jsx";
import ContactInfo from "../components/Home/ContactInfo.jsx";
import SectionBgImage from "../components/Home/SectionBgImage.jsx";
import videoBanner from "../assets/images/video_banner.mp4";
import Navbar from "../components/Navbar.jsx";
import Seo from "../components/Seo.jsx";

export function Home() {
  const [isIOS, setIsIOS] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    localStorage.setItem("colorFooter", "blue");
    localStorage.setItem("colorNav", "white");

    const ua = navigator.userAgent;
    const isIOSDevice =
      /iPad|iPhone|iPod/.test(ua) &&
      /Safari/.test(ua) &&
      !/CriOS/.test(ua) &&
      !/FxiOS/.test(ua);

    setIsIOS(isIOSDevice);

    if (isIOSDevice && videoRef.current) {
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => setIsPlaying(true))
          .catch((err) => console.log("iOS bloqueo autoplay:", err));
      }
    }
  }, []);

  const handlePlay = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  return (
    <div>
      <Seo
        pageKey="home"
        pathByLang={{
          en: "/",
          es: "/es",
        }}
        site="https://www.atmnetss.com"
        image="https://www.atmnetss.com/og-image.jpg"
      />

      <div className="relative">
        <video
          ref={videoRef}
          src={videoBanner}
          loop
          muted
          playsInline
          autoPlay={!isIOS}
          className="absolute w-full h-full object-cover"
          style={{ zIndex: -1 }}
        />
        {isIOS && !isPlaying && (
          <button
            onClick={handlePlay}
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-black text-3xl px-6 py-3 rounded-full z-10"
          ></button>
        )}
        <Navbar />
        <InfoBanner />
      </div>

      <ImageSection />
      <SectionBgImage />
      <ContactInfo />
    </div>
  );
}
